/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_PurposeInputs */

const cs_investor_purpose = /** @type {(inputs: Investor_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účel`)
};

const en_investor_purpose = /** @type {(inputs: Investor_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose`)
};

/**
* | output |
* | --- |
* | "Purpose" |
*
* @param {Investor_PurposeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_purpose = /** @type {((inputs?: Investor_PurposeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_PurposeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_purpose(inputs)
	return cs_investor_purpose(inputs)
});